import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon, toast, ExpandedTooltip } from '@livable/saas-react-components';
import { Button, Typography, InputLabel, FormControl, OutlinedInput, InputAdornment, IconButton, Chip } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
// import { useStore } from 'src/stores';
import useBillingCredentialItemStyles from './styles';
export const UtilityCredentialItem = observer(_ref => {
  var _credentialData$quest;
  let credentialData = _ref.credentialData,
    reportCredentialModalTrigger = _ref.reportCredentialModalTrigger;
  // const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const classes = useBillingCredentialItemStyles();
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isShowHiddenPassword = _useState2[0],
    setIsShowHiddenPassword = _useState2[1];
  const writeToClipboard = textValue => {
    navigator.clipboard.writeText(textValue).then(() => {
      toast('success', {
        body: ['Successfully copied to clipboard!']
      });
    }).catch(error => {
      toast('error', {
        body: ['Error coping to clipboard', error]
      });
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.utilityCredentialItemContainer,
    id: 'utilityCredentialItemContainer'
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.utilityCredentialItemCredentialSection
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.utilityCredentialItemCredentialDetails
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.utilityCredentialUsernamePasswordSection, " ").concat(classes.inputToPreviewStyle)
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "username"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light",
    component: 'span'
  }, "Username")), /*#__PURE__*/React.createElement(OutlinedInput, {
    id: "username",
    type: "text",
    label: "Username",
    variant: "filled",
    disabled: true,
    value: credentialData.username,
    endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end"
    }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
      type: "grey",
      title: 'Copy username',
      placement: "top"
    }, /*#__PURE__*/React.createElement(IconButton, {
      onClick: () => {
        writeToClipboard(credentialData.username);
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "document-file-copy"
    }))))
  })), /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "Password"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light",
    component: 'span'
  }, "Password")), /*#__PURE__*/React.createElement(OutlinedInput, {
    id: "Password",
    type: "showPassword",
    label: "Password",
    variant: "filled",
    value: isShowHiddenPassword ? credentialData.password : '••••••••••••',
    disabled: true,
    endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end"
    }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
      type: "grey",
      title: 'Show/Hide',
      placement: "top"
    }, /*#__PURE__*/React.createElement(IconButton, {
      onClick: () => {
        console.log('Show hidden');
        if (!isShowHiddenPassword) setTimeout(() => {
          console.log('setTimeout Show hidden');
          setIsShowHiddenPassword(false);
        }, 10000);
        setIsShowHiddenPassword(!isShowHiddenPassword);
      }
    }, !isShowHiddenPassword ? /*#__PURE__*/React.createElement(Icon, {
      type: "show-eye-on"
    }) : /*#__PURE__*/React.createElement(Icon, {
      type: "show-eye-off"
    }))), /*#__PURE__*/React.createElement(ExpandedTooltip, {
      type: "grey",
      title: 'Copy credential',
      placement: "top"
    }, /*#__PURE__*/React.createElement(IconButton, {
      onClick: () => {
        writeToClipboard(credentialData.password);
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "document-file-copy"
    }))))
  }))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.inputToPreviewStyle)
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "website"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light",
    component: 'span'
  }, t('Website'))), /*#__PURE__*/React.createElement(OutlinedInput, {
    id: "website",
    type: "text",
    label: "Website",
    variant: "filled",
    disabled: true,
    value: credentialData.website,
    endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end"
    }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
      type: "grey",
      title: t('Copy website'),
      placement: "top"
    }, /*#__PURE__*/React.createElement(IconButton, {
      onClick: () => {
        writeToClipboard(credentialData.website);
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "document-file-copy"
    }))))
  })))), (credentialData === null || credentialData === void 0 || (_credentialData$quest = credentialData.questions) === null || _credentialData$quest === void 0 ? void 0 : _credentialData$quest.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.utilityCredentialItemCredentialQuestions, " ").concat(classes.inputToPreviewStyle)
  }, credentialData.questions.map((questionGroup, index) => {
    const _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isShowHiddenQuestionGroup = _useState4[0],
      setIsShowHiddenQuestionGroup = _useState4[1];
    return /*#__PURE__*/React.createElement(FormControl, {
      variant: "outlined",
      fullWidth: true
    }, /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: "username"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      color: "light",
      component: 'span'
    }, "Security question ".concat(index + 1, ":")), ' ', /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      component: 'span'
    }, "".concat(questionGroup.questionName))), /*#__PURE__*/React.createElement(OutlinedInput, {
      id: "website",
      type: "text",
      label: "Website",
      variant: "filled",
      disabled: true,
      value: isShowHiddenQuestionGroup ? questionGroup.answerName : '••••••••••••',
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
        type: "grey",
        title: 'Show/Hide',
        placement: "top"
      }, /*#__PURE__*/React.createElement(IconButton, {
        onClick: () => {
          console.log('Show hidden');
          if (!isShowHiddenQuestionGroup) setTimeout(() => {
            console.log('setTimeout Show hidden');
            setIsShowHiddenQuestionGroup(false);
          }, 10000);
          setIsShowHiddenQuestionGroup(!isShowHiddenQuestionGroup);
        }
      }, !isShowHiddenQuestionGroup ? /*#__PURE__*/React.createElement(Icon, {
        type: "show-eye-on"
      }) : /*#__PURE__*/React.createElement(Icon, {
        type: "show-eye-off"
      }))), /*#__PURE__*/React.createElement(ExpandedTooltip, {
        type: "grey",
        title: 'Copy Answer',
        placement: "top"
      }, /*#__PURE__*/React.createElement(IconButton, {
        onClick: () => {
          writeToClipboard(questionGroup.answerName);
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "document-file-copy"
      }))))
    }));
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.utilityCredentialItemReportSection
  }, /*#__PURE__*/React.createElement(Chip, {
    label: /*#__PURE__*/React.createElement("div", {
      className: classes.utilityCredentialItemReportChipChildren
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.utilityCredentialItemReportLabel
    }, "If you find the credentials to be incorrect, please", ' '), !!reportCredentialModalTrigger ? reportCredentialModalTrigger : /*#__PURE__*/React.createElement(Button, {
      variant: "actionButton",
      onClick: () => {
        console.log('Report credentials issue clicked');
      },
      'custom-attribute': '420-utility-credentials-item'
    }, t('Report credentials issue'))),
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "info"
    }),
    variant: "info"
  })));
});